import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FeedAuditEnrichmentPage = lazy(
  () => import('~/features/feed-audit/pages/feed-audit-enrichment-page'),
);

/** Persists the active results view (`tab`) and the focused product (`productId`)
 *  in the URL, so a reload or a shared link lands on the same tab + product. */
const searchSchema = z.object({
  tab: z.enum(['stats', 'products']).catch('stats'),
  productId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/feed-audit/$id')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

/** Bridges the route's path param into the results page props. */
function RouteComponent() {
  const { id } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <FeedAuditEnrichmentPage feedAuditId={id} />
    </Suspense>
  );
}
